//
import Service from '@/services/api/service'
import SlTaxDocumentModel from '@/models/Sale/SlTaxDocument'

/**
 * This class describes a sl tax document.
 *
 * @class      SlTaxDocument (name)
 */
export default class SlTaxDocument extends Service {
  
  /**
   * The sl tax document includes
   */
  static includes = [
    'sl_customer_account',
    'sl_customer_account.sl_customer',
    'sl_sale_invoice',
  ]

  /**
   * The sl tax document model
   */
  static model = SlTaxDocumentModel

  /**
   * Returns a customer detail representation of the object.
   * @return     {<type>}  Customer detail representation of the object.
   */
  static toCustomerDetail() {
    return class extends SlTaxDocumentModel {
      static includes = [
        'sl_customer',
        'sl_customer_branch_offices',
      ]
    }
  }
}
